module.exports = __webpack_public_path__ + "img/bg_1440_0_1011_1.83765635.png";